
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M16.95 10.23L11.29 15.89C10.9 16.28 10.27 16.28 9.88 15.89L7.05 13.06C6.66 12.67 6.66 12.04 7.05 11.65C7.44 11.26 8.07 11.26 8.46 11.65L10.58 13.77L15.53 8.82001C15.92 8.43001 16.55 8.43001 16.94 8.82001C17.34 9.21001 17.34 9.84001 16.95 10.23ZM4 12C4 9.67001 5.02 7.58001 6.62 6.12001L8.15 7.65001C8.46 7.96001 9 7.74001 9 7.29001V3.00001C9 2.72001 8.78 2.50001 8.5 2.50001H4.21C3.76 2.50001 3.54 3.04001 3.86 3.35001L5.2 4.70001C3.24 6.52001 2 9.11001 2 12C2 16.75 5.32 20.73 9.76 21.75C10.39 21.89 11 21.42 11 20.77C11 20.3 10.67 19.9 10.21 19.79C6.66 18.98 4 15.8 4 12ZM22 12C22 7.25001 18.68 3.27001 14.24 2.25001C13.61 2.11001 13 2.58001 13 3.23001C13 3.70001 13.33 4.10001 13.79 4.21001C17.34 5.02001 20 8.20001 20 12C20 14.33 18.98 16.42 17.38 17.88L15.85 16.35C15.54 16.04 15 16.26 15 16.71V21C15 21.28 15.22 21.5 15.5 21.5H19.79C20.24 21.5 20.46 20.96 20.14 20.65L18.8 19.3C20.76 17.48 22 14.89 22 12Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-published-with-changes`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconPublishedWithChanges

    ```js
    <b-new-b-icon-published-with-changes />
    ```
</docs>


